import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { LocationsExplorer } from "@/components/site/LocationsExplorer";
import { LOCATIONS, fullAddress } from "@/content/locations";
import { SITE_URL } from "@/content/site";

const ld = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "TeaDM locations",
  itemListElement: LOCATIONS.map((l, i) => ({ "@type": "ListItem", position: i + 1, name: l.name, url: `${SITE_URL}/locations/${l.slug}`, description: fullAddress(l) })),
};

export default function Locations() {
  return (
    <>
      <Seo title="TeaDM Locations — Falls Church, Fairfax, Vienna & Sterling" description="Find a TeaDM bubble tea shop near you in Northern Virginia: Falls Church, Fairfax, Vienna and Sterling. Hours, directions and online ordering." path="/locations" jsonLd={ld} />
      <PageHero testId="locations-hero" bg="#2e9e4f" eyebrow="Locations" lines={["Find your", "TeaDM."]} intro="Four TeaDM stores across Northern Virginia. Tap a store to order straight from its Toast page." />
      <section className="bg-[#efe4d6] py-16 sm:py-24">
        <div className="wrap"><LocationsExplorer /></div>
      </section>
    </>
  );
}
